<template>
  <div class="calandr_main no_mobile calendar_desktop relative">
    <!-- view select -->
    <div class="select-month-wrap no-print">
      <select2 v-model="viewBySelect">
        <option
          :value="view.value"
          v-for="view in viewOptions"
          :key="view.value"
        >
          {{ view.text }}
        </option>
      </select2>
    </div>

    <!-- Time -->
    <TimeRangeArrows
      v-if="viewBySelect != 'list' && viewBySelect != 'month'"
      @updateTimeStep="updateTimeStep"
    />

    <!-- switch -->
    <div
      v-if="viewBySelect == 'day' || viewBySelect == 'week'"
      class="switch-container has-switch-tabs"
    >
      <label for="switch-tabs" class="switch switch-tabs flex flex--center">
        <input id="switch-tabs" type="checkbox" v-model="showAppointment" />
        <span class="slider"></span>
        <div class="switch-tab first">
          <img class="reg" src="/assets/img/svg/tab-list.svg" alt="icon" />
          <img class="hov" src="/assets/img/svg/tab-list-hov.svg" alt="icon" />
          <div>הצג תורים</div>
        </div>
        <div class="switch-tab">
          <img class="reg" src="/assets/img/svg/tab-block.svg" alt="icon" />
          <img class="hov" src="/assets/img/svg/tab-block-hov.svg" alt="icon" />
          <div>עריכת בלוק</div>
        </div>
      </label>
      <span> </span>
    </div>

    <div
      v-if="viewBySelect === 'list'"
      class="no_mobile no-print flex only-list-day-print"
      style="gap: 10px;"
    >
      <a
        class="clear-filters flex"
        href="javascript:void(0)"
        @click="exportToExcel"
      >
        <img src="/assets/img/svg/download.svg" alt="" />ייצוא לקובץ
      </a>

      <!-- print -->
      <div class="bt_blue print-btn-small" @click="print">
        הדפסה
      </div>
    </div>

    <div
      id="app"
      class="flex items--start relative"
      :class="{ listDay: viewBySelect === 'list' }"
    >
      <!-- list apps -->
      <appointment-list
        v-if="viewBySelect === 'list'"
        :appointmentList="appointmentList"
      />

      <div class="side-app-caln" v-if="activeView === 'day'">
        <!-- small calendar -->
        <vue-cal
          xsmall
          locale="he"
          :time="false"
          :startWeekOnSunday="true"
          :selected-date="selectedDate"
          hide-view-selector
          active-view="month"
          :disable-views="['years', 'year', 'week', 'day']"
          @cell-focus="onCellFocus"
          class="vuecal--green-theme vuecal--rounded-theme mini-month has-push-top no-print"
          :events="smallCalEvents"
          events-count-on-year-view
          @view-change="changeSmallCalendar"
        >
          <template v-slot:weekday-heading="{ heading }">
            <span v-if="heading.label == 'ראשון'">א׳</span>
            <span v-if="heading.label == 'שני'">ב׳</span>
            <span v-if="heading.label == 'שלישי'">ג׳</span>
            <span v-if="heading.label == 'רביעי'">ד׳</span>
            <span v-if="heading.label == 'חמישי'">ה׳</span>
            <span v-if="heading.label == 'שישי'">ו׳</span>
            <span v-if="heading.label == 'שבת'">ש׳</span>
          </template>
          <template v-slot:events-count="{ events }">
            <span>
              {{ countDot(events) }}
            </span>
          </template>
        </vue-cal>
        <!-- app types -->
        <TypesCount
          :typesCount="typesCount"
          :appointmentsDayCount="appointmentsDayCount"
          :selectedDate="selectedDate"
        />
        <!-- /app types -->
        <ScheduledByList :scheduledByList="scheduledByList" />
      </div>
      <!-- calendar -->
      <vue-cal
        ref="vuecal"
        class="vuecal--green-theme"
        locale="he"
        :startWeekOnSunday="true"
        :active-view.sync="activeView"
        :disable-views="['years', 'year']"
        hide-view-selector
        :time-from="timeFrom"
        :time-to="timeTo"
        :timeStep="timeStep"
        :snap-to-time="5"
        :timeCellHeight="50"
        :events="eventsToEdit"
        events-on-month-view="short"
        :selected-date="selectedDate"
        @event-mouse-enter="enterHoverEvent"
        @event-mouse-leave="leaveHoverEvent"
        :cell-click-hold="false"
        @cell-click="cellClick"
        @cell-dblclick="changeView"
        :on-event-click="onEventClick"
        :on-event-dblclick="onEventDblClick"
        @view-change="initCalendarDesktop"
        @event-drop="onEventDrop"
        @event-duration-change="onChangeDuration"
        showEventCreationDialog
        :overlapsPerTimeStep="false"
        :min-event-width="0"
        :editable-events="{
          title: false,
          drag: true,
          resize: true,
          delete: false,
          create: true
        }"
        :drag-to-create-event="false"
      >
        <!-- resize-x -->
        <template v-slot:event="{ event, view }">
          <app-view-event
            v-if="showAppointment || view == 'month'"
            :event="event"
            :view="view"
            :viewBySelect="viewBySelect"
            :selectedEventHover="selectedEventHover"
            :currentOpen="currentOpenDrop"
            @updateCurrentOpen="updateCurrDropOpen"
            @initCalendarDesktop="initCalendarDesktop"
          />
          <block-view-event
            v-else
            :event="event"
            @editBlock="ev => $emit('editBlock', ev)"
            @deleteBlock="ev => $emit('deleteBlock', ev)"
            @disableBlock="ev => $emit('disableBlock', ev)"
            @activateBlock="ev => $emit('activateBlock', ev)"
          />
        </template>
      </vue-cal>
    </div>
    <ListPdf
      :appointmentList="appointmentList"
      :selectedDate="selectedDate"
      :typesCount="typesCount"
      :appointmentsDayCount="appointmentsDayCount"
      :scheduledByList="scheduledByList"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.js";
import "vue-cal/dist/vuecal.css";
import Error from "@/components/Popups/Error";
import AppointmentList from "@/components/Dashboard/List/AppointmentList";
import ListPdf from "@/components/Shared/ListPdf";
import ScheduledByList from "@/components/Dashboard/HomeDesktop/ScheduledByList";
import TypesCount from "@/components/Dashboard/HomeDesktop/TypesCount";
import TimeRangeArrows from "@/components/Shared/TimeRangeArrows";
import AppViewEvent from "./AppViewEvent.vue";
import BlockViewEvent from "@/components/Dashboard/HomeDesktop/BlockViewEvent";
import { getHash } from "../../../utilities/hash.js";
import { getTime, getDate, getDuration } from "../../../utilities/dates.js";
import { exportAppointmentsToExcel } from "../../../utilities/export-to-excel";

export default {
  name: "HomeDesktop",
  components: {
    VueCal,
    AppointmentList,
    ListPdf,
    ScheduledByList,
    TypesCount,
    TimeRangeArrows,
    AppViewEvent,
    BlockViewEvent
  },
  props: {
    events: {
      type: Array,
      require: true
    },
    smallCalEvents: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      lastclickev: false,
      lastclicktype: false,
      activeView: "month",
      selectedEventHover: null,
      selectedDate: new Date(),
      viewOptions: [
        { value: "month", text: "תצוגה חודשית" },
        { value: "week", text: "תצוגה שבועית" },
        { value: "day", text: "תצוגה יומית" },
        { value: "list", text: "רשימת תורים" }
      ],
      copyEvents: null,
      viewBySelect: "month",
      isChangeView: false,
      isSmallCalEvDelay: false,
      timeStep: 15,
      showAppointment: true,
      currentOpenDrop: ""
    };
  },
  watch: {
    hashData(val) {
      if (val && val.date) {
        if (this.selectedDate !== new Date(val.date)) {
          this.selectedDate = new Date(val.date);
        }
        if (this.viewBySelect !== val.view) {
          this.viewBySelect = val.view;
          if (val.view === "list") this.activeView = "day";
          else this.activeView = val.view;
        }
        this.changeTimeStep();
      } else {
        this.selectedDate = new Date();
        this.activeView = "month";
        this.viewBySelect = "month";
      }
    },
    events() {
      this.copyEvents = [...this.events];
      this.changeTimeStep();
    },
    viewBySelect(val) {
      this.activeView = val === "list" ? "day" : val;
      if (val === "list") {
        this.$emit("initCalendarDesktop", {
          date: this.selectedDate,
          forceUpdate: true
        });
      }
    }
  },
  computed: {
    isEditable() {
      return this.activeView === "month";
    },
    appointmentList() {
      const selectedDate = this.getDate(this.selectedDate);
      let selectedDateEvents = this.events.filter(
        e => e.type === "appointment" && selectedDate === this.getDate(e.start)
      );
      // remove fake time that crated for better view
      selectedDateEvents = selectedDateEvents.map(e => {
        return { ...e, end: e.real_end, start: e.real_start };
      });
      return selectedDateEvents.sort((a, b) => a.start - b.start);
    },
    eventsToEdit() {
      if (this.viewBySelect != "month") {
        if (!this.showAppointment) {
          return this.copyEvents.filter(ev => ev.type == "block");
        } else {
          return this.copyEvents;
        }
      }

      // format events for month view
      let eventsToEdit = [];
      this.events.forEach(ev => {
        if (ev.type === "block") {
          const hours = this.getTime(ev.end) + " - " + this.getTime(ev.start);
          const appointments = this.countAppointments(ev.start);
          const availableAppointments = this.availableAppointments(ev.start);
          let index = -1;

          if (eventsToEdit.length) {
            const today = this.getDate(ev.start);
            index = eventsToEdit.findIndex(
              e => today === this.getDate(e.start)
            );
          }
          if (index === -1) {
            let monthEv = {
              start: ev.start,
              end: ev.end,
              hours: [hours],
              appointments: appointments,
              availableAppointments: availableAppointments,
              type: "month",
              resizable: false,
              draggable: false
            };
            eventsToEdit.push(monthEv);
          } else {
            eventsToEdit[index].hours.push(hours);
            eventsToEdit[index].availableAppointments += availableAppointments;
          }
        }
      });
      return [...this.events, ...eventsToEdit];
    },
    timeFrom() {
      if (this.activeView === "day") {
        const today = this.getDate(this.selectedDate);
        const evDates = this.events.filter(
          ev => this.getDate(ev.start) === today
        );
        let hoursStart = evDates.map(d => {
          return parseInt(this.getTime(d.start).slice(0, -3));
        });
        let min = Math.min(...hoursStart);
        if (!min) return 0 * 60;
        else return (min - 1) * 60;
      } else if (this.activeView === "week") {
        let weekEvents = [];
        let first = this.selectedDate.getDate() - this.selectedDate.getDay();
        let firstDay = new Date(this.selectedDate.setDate(first));
        for (let i = 0; i < 7; i++) {
          let date = firstDay.addDays(i);
          const find = this.events.filter(
            ev => this.getDate(ev.start) === this.getDate(date)
          );
          weekEvents = [...weekEvents, ...find];
        }
        let hoursStart = weekEvents.map(d => {
          return parseInt(this.getTime(d.start).slice(0, -3));
        });
        let min = Math.min(...hoursStart);
        if (!min) return 0 * 60;
        else return (min - 1) * 60;
      }
      return 0 * 60;
    },
    timeTo() {
      if (this.activeView === "day") {
        const today = this.getDate(this.selectedDate);
        const evDates = this.events.filter(
          ev => this.getDate(ev.start) === today
        );
        let hoursEnd = evDates.map(d => {
          return parseInt(this.getTime(d.end).slice(0, -3));
        });
        let max = Math.max(...hoursEnd);
        if (max === 24) return 24 * 60;
        else return (max + 1) * 60;
      } else if (this.activeView === "week") {
        let weekEvents = [];
        let first = this.selectedDate.getDate() - this.selectedDate.getDay();
        let firstDay = new Date(this.selectedDate.setDate(first));
        for (let i = 0; i < 7; i++) {
          let date = firstDay.addDays(i);
          const find = this.events.filter(
            ev => this.getDate(ev.start) === this.getDate(date)
          );
          weekEvents = [...weekEvents, ...find];
        }
        let hoursEnd = weekEvents.map(d => {
          return parseInt(this.getTime(d.end).slice(0, -3));
        });
        let max = Math.max(...hoursEnd);
        if (max === 24) return 24 * 60;
        else return (max + 1) * 60;
      }
      return 25 * 60;
    },
    typesCount() {
      if (!this.copyEvents || !this.selectedDate) return null;
      return this.copyEvents.reduce((acc, ev) => {
        const selectedFormat = this.getDate(this.selectedDate);
        const evFormat = this.getDate(ev.start);
        if (ev.type == "appointment" && selectedFormat == evFormat) {
          const key = ev.appointmentName;
          if (!acc[key]) acc[key] = 0;
          acc[key] += 1;
        }
        return acc;
      }, {});
    },
    appointmentsDayCount() {
      if (!this.copyEvents || !this.selectedDate) return 0;
      const filtered = this.copyEvents.filter(ev => {
        const selectedFormat = this.getDate(this.selectedDate);
        const evFormat = this.getDate(ev.start);
        if (ev.type === "appointment" && selectedFormat == evFormat)
          return true;
        return false;
      });
      return filtered.length;
    },
    scheduledByList() {
      if (!this.copyEvents || !this.selectedDate) return null;
      return this.copyEvents.reduce((acc, ev) => {
        const selectedFormat = this.getDate(this.selectedDate);
        const evFormat = this.getDate(ev.start);
        if (ev.type == "appointment" && selectedFormat == evFormat) {
          const key = ev.scheduled_by;
          if (!acc[key]) {
            const img = this.getScheduledBy(key);
            if (img) acc[key] = img;
          }
        }
        return acc;
      }, {});
    }
  },
  methods: {
    ...mapMutations(["SET_IS_CHANGE_APP"]),
    getTime,
    getDate,
    getDuration,
    /**
     * For week view show event on hover
     * @param {Object} ev
     */
    enterHoverEvent(ev) {
      if (this.activeView !== "week") return;
      this.selectedEventHover = ev;
    },
    /**
     * For week view leave event on hover
     * @param {Object} ev
     */
    leaveHoverEvent(ev) {
      if (this.activeView !== "week") return;
      this.selectedEventHover = null;
    },
    /**
     * For day & week view update time step in vue cal
     * @param {bool} isIncrease
     */
    updateTimeStep(isIncrease) {
      if (isIncrease && this.timeStep < 30) this.timeStep += 5;
      else if (!isIncrease && this.timeStep > 5) this.timeStep -= 5;
      if (this.timeStep == 5) {
        this.copyEvents = this.events.map(e => {
          if (e.type == "block") return { ...e };
          return { ...e, end: e.real_end, start: e.real_start };
        });
      } else {
        this.copyEvents = [...this.events];
      }
    },
    /**
     * Triggered when view changed
     * @param {Object} ev
     * update view, date, events array
     */
    initCalendarDesktop(ev) {
      if (
        this.viewBySelect === "day" &&
        this.activeView == "week" &&
        this.isChangeView
      )
        return;
      this.selectedDate = ev.startDate;
      if (this.activeView !== "day") this.viewBySelect = this.activeView;
      window.location.hash = getHash({
        date: this.$moment(this.selectedDate).format("YYYY-MM-DD"),
        view: this.viewBySelect
      });
      this.$emit("initCalendarDesktop", {
        currentDate: new Date(ev.startDate)
      });
      this.isChangeView = false;
      this.isSmallCalEvDelay = true;
      setTimeout(() => {
        this.isSmallCalEvDelay = false;
      }, 700);
    },
    /**
     * Triggered when view changed in small vue calendar
     * @param {Object} ev
     * update small events array
     */
    changeSmallCalendar(ev) {
      setTimeout(
        () => {
          this.$emit("initCalendarDesktop", {
            currentDate: new Date(ev.startDate),
            type: "small"
          });
          this.isSmallCalEvDelay = false;
        },
        this.isSmallCalEvDelay ? 700 : 0
      );
    },
    /**
     * Triggered when double click on event
     * @param {Object} ev
     * Day, Week view - change to appointment route
     * Month - change view
     */
    onEventDblClick(ev, e) {
      this.lastclicktype = ev.type;
      if (
        ev.type === "appointment" &&
        ev.id &&
        (this.activeView === "day" || this.activeView === "week")
      ) {
        this.$router.push({ name: "app-info", params: { id: ev.id } });
      } else if (this.activeView === "month" || this.activeView === "week") {
        this.selectedDate = ev.start;
        window.location.hash = getHash({
          date: this.$moment(ev.start).format("YYYY-MM-DD"),
          view: "day"
        });
        this.viewBySelect = "day";
        this.activeView = "day";
      }
    },
    /**
     * Triggered when click on event
     * @param {Object} ev
     * If new event clicked push to create appointment route withe time & block id
     */
    onEventClick(ev, e) {
      if (this.activeView == "month" || ev.type !== "appointment") return;
      const classList = [...e.target.classList];
      /// Open dot-menu
      if (classList.includes("nav-dots") || classList.includes("nav-dot")) {
        return;
      }
      if (typeof ev.newEvent != "undefined" && ev.newEvent == true) {
        const blockId = this.findBlock(ev.start, ev.end, true);
        this.$router.push(
          "/app-add?start=" +
            this.$moment(ev.start).format("YYYY-MM-DDTLT:00") +
            "&end=" +
            this.$moment(ev.end).format("YYYY-MM-DDTLT:00") +
            "&block_id=" +
            blockId
        );
        return;
      }
    },
    cellClick(ev) {
      this.lastclicktype = false;
    },
    /**
     * Triggered when click on ceil
     * @param {Object} ev
     * Day, Week view - create new event
     * Month - change view
     */
    changeView(ev) {
      if (this.activeView === "month") {
        this.isChangeView = true;
        window.location.hash = getHash({
          date: this.$moment(ev).format("YYYY-MM-DD"),
          view: "day"
        });
        this.viewBySelect = "day";
        this.activeView = "day";
      } else if (this.activeView === "day" && this.lastclicktype == "block") {
        const isBefore = this.$moment(ev).isBefore(new Date());
        if (isBefore) return;
        let event = ev;
        const date = this.$moment(ev).format("YYYY-MM-DD");
        const hr = this.$moment(ev).format("HH");
        let min = this.$moment(ev).minutes();
        if (min % 5 !== 0) {
          min = this.$moment().minutes(Math.round(min / 5) * 5);
          min = this.$moment(min).format("mm");
          event = new Date(date + " " + hr + ":" + min);
        }
        this.lastclickev = event;
        this.$refs.vuecal.createEvent(event, 15, {
          patientName: "תור חדש",
          type: "appointment",
          class: "appointment short_app",
          newEvent: true
        });
      }
    },
    countDot(events) {
      return events ? events.filter(e => e.type === "appointment").length : 0;
    },
    onCellFocus(ev) {
      this.selectedDate = ev;
      window.location.hash = getHash({
        date: this.$moment(ev).format("YYYY-MM-DD"),
        view: this.viewBySelect
      });
    },
    countAppointments(currentDate) {
      let today = this.$moment(currentDate).format("L");
      return this.events
        ? this.events.filter(
            e =>
              e.type === "appointment" &&
              today === this.$moment(e.start).format("L")
          ).length
        : 0;
    },
    availableAppointments(currentDate) {
      let today = this.$moment(currentDate);
      let appointments = 0;
      let timeInMinutes = 0;
      for (const todayElement of this.events) {
        let start = this.$moment(new Date(todayElement.start));
        let end = this.$moment(new Date(todayElement.end));

        if (
          start.isSame(today, "day") &&
          typeof todayElement.appointment_id == "undefined"
        ) {
          timeInMinutes = end.diff(start, "m");
          if (timeInMinutes < 0) timeInMinutes *= -1;
          appointments += Math.floor(timeInMinutes / 20);
        }
      }
      return appointments;
    },
    print() {
      window.focus();
      window.print();
    },
    async onChangeDuration(ev) {
      const hasNoDuration =
        ev.event.start.toString() == ev.event.end.toString();
      if (new Date() > ev.event.start || hasNoDuration) {
        const index = this.copyEvents.findIndex(
          e => e.type === "appointment" && e.id === ev.event.id
        );
        this.copyEvents[index].start = ev.originalEvent.start;
        this.copyEvents[index].end = ev.originalEvent.end;
        this.copyEvents[index].real_start = ev.originalEvent.real_start;
        this.copyEvents[index].real_end = ev.originalEvent.real_end;
        this.$modal.show(Error, {
          title: hasNoDuration
            ? "משך התור חייב להיות 5 דקות לפחות"
            : "ניתן לשנות שיבוץ ניתוח/תור בתאריך נוכחי או עתידי בלבד"
        });
        return;
      }

      const blockId = this.findBlock(ev.event.start, ev.event.end);
      if (
        typeof ev.event.newEvent != "undefined" &&
        ev.event.newEvent == true
      ) {
        return;
      }
      const isFindApp = this.findApp(ev.event.start, ev.event.end, ev.event.id);
      if (!blockId || isFindApp) {
        let title;
        if (!blockId)
          title =
            "לתשומת ליבך, לא ניתן לקבוע תור מחוץ לשעות הבלוק יש לבחור שעה אחרת או לעדכן את שעות הבלוק";
        else if (isFindApp)
          title = "לתשומת ליבך, לא ניתן לזמן תור כפול באותה שעה.";
        this.$emit("initCalendarDesktop", {
          currentDate: new Date(ev.event.start),
          forceUpdate: true
        });
        this.$modal.show(Error, { title });
      } else {
        let appointment = {
          id: ev.event.id,
          start: this.$moment(ev.event.start).format("YYYY-MM-DDTLT:00"),
          end: this.$moment(ev.event.end).format("YYYY-MM-DDTLT:00"),
          over_block_id: blockId,
          title: "appointment"
        };

        const index = this.copyEvents.findIndex(
          e => e.type === "appointment" && e.id === ev.event.id
        );
        if (index !== -1) {
          this.copyEvents[index].start = ev.event.start;
          this.copyEvents[index].end = ev.event.end;
          const e = this.$moment(ev.event.end);
          const s = this.$moment(ev.event.start);
          const duration = this.$moment.duration(e.diff(s));
          const min = duration.asMinutes();
          this.copyEvents[index].app_duration = min;
        }

        await this.$API.setAppointementsDatetime([appointment]);
        await this.SET_IS_CHANGE_APP(true);
      }
    },
    async onEventDrop(ev) {
      // if before tody error
      if (new Date() > ev.event.start) {
        this.copyEvents = [...this.copyEvents];
        this.$modal.show(Error, {
          title: "ניתן לשנות שיבוץ ניתוח/תור בתאריך נוכחי או עתידי בלבד"
        });
        return;
      }
      // if is new app
      if (typeof ev.event.newEvent != "undefined" && ev.event.newEvent) {
        return;
      }
      // check block and another app exist
      const blockId = this.findBlock(ev.event.start, ev.event.end);
      const isFindApp = this.findApp(
        ev.event.start,
        ev.event.end,
        ev.event.id,
        blockId
      );
      // adjustment app time
      let newTimeApp;
      if (!blockId || isFindApp) {
        newTimeApp = this.adjustmentAppTime(
          ev.event.start,
          ev.event.end,
          ev.event.id
        );
      }
      if ((!blockId || isFindApp) && !newTimeApp) {
        // event drop false
        let title;
        if (!blockId)
          title =
            "לתשומת ליבך, לא ניתן לקבוע תור מחוץ לשעות הבלוק יש לבחור שעה אחרת או לעדכן את שעות הבלוק";
        else if (isFindApp)
          title = "לתשומת ליבך, לא ניתן לזמן תור כפול באותה שעה.";
        this.copyEvents = [...this.copyEvents];
        this.$modal.show(Error, { title });
      } else {
        // event drop true
        const index = this.copyEvents.findIndex(
          e => e.type === "appointment" && e.id === ev.event.id
        );
        let newStart;
        let newEnd;
        if (newTimeApp) {
          newStart = new Date(
            this.$moment(newTimeApp.start).format("YYYY-MM-DDTLT:00")
          );
          newEnd = newTimeApp.end;
        } else {
          newStart = ev.event.start;
          if (index !== -1) {
            newEnd = this.$moment(ev.event.start).add(
              this.copyEvents[index].app_duration,
              "minutes"
            );
          } else {
            newEnd = ev.event.end;
          }
        }
        let appointment = {
          id: ev.event.id,
          start: this.$moment(newStart).format("YYYY-MM-DDTLT:00"),
          end: this.$moment(newEnd).format("YYYY-MM-DDTLT:00"),
          over_block_id: newTimeApp ? newTimeApp.blockId : blockId,
          title: "appointment"
        };

        if (index !== -1) {
          this.copyEvents[index].start = newStart;
          this.copyEvents[index].end = new Date(
            this.$moment(newEnd).format("YYYY-MM-DDTLT:00")
          );
        }

        await this.$API.setAppointementsDatetime([appointment]);
        await this.SET_IS_CHANGE_APP(true);
      }
    },
    findBlock(start, end) {
      let startHApp = this.getTime(start);
      let endHApp = this.getTime(end);
      if (endHApp == "00:00") endHApp = "23:59";

      let todayEv = [];
      this.events.forEach(ev => {
        if (
          ev.type === "block" &&
          this.getDate(start) === this.getDate(ev.start)
        ) {
          const hourS = this.getTime(ev.start);
          const hourE = this.getTime(ev.end);
          todayEv.push({ ...ev, start: hourS, end: hourE });
        }
      });
      if (!todayEv.length) return null;
      else if (todayEv.length === 1) {
        if (startHApp >= todayEv[0].start && endHApp <= todayEv[0].end)
          return todayEv[0].id;
        else return null;
      } else if (todayEv.length > 1) {
        let selectedId = null;
        todayEv.forEach(ev => {
          if (startHApp >= ev.start && endHApp <= ev.end) selectedId = ev.id;
        });
        return selectedId;
      }
      return null;
    },
    findApp(start, end, appId) {
      let wanted_date_start = this.$moment(start);
      let wanted_date_end = this.$moment(end);

      let todayEv = [];
      this.copyEvents.forEach(ev => {
        if (
          ev.type === "appointment" &&
          this.getDate(start) === this.getDate(ev.start) &&
          ev.id !== appId
        ) {
          todayEv.push(ev);
        }
      });
      if (!todayEv.length) return false;
      const sortedTodayEv = todayEv.sort((a, b) => a.start - b.start);
      let error_need_to_short = false;
      let error_contain_app = false;

      for (const index in sortedTodayEv) {
        const appointment = sortedTodayEv[index];
        const appointement_start = this.$moment(
          appointment.start,
          "YYYY-MM-DD HH:mm:ss"
        );
        const appointement_end = this.$moment(
          appointment.end,
          "YYYY-MM-DD HH:mm:ss"
        );
        if (
          (wanted_date_start.isAfter(appointement_start) &&
            wanted_date_start.isBefore(appointement_end)) ||
          (wanted_date_end.isAfter(appointement_start) &&
            wanted_date_end.isBefore(appointement_end))
          /*(wanted_date_start.isSame(appointement_start) &&
                    wanted_date_end.isSame(appointement_end))
                (wanted_date_start.isSameOrBefore(appointement_start) &&
                    wanted_date_end.isSameOrAfter(appointement_end))*/
        ) {
          error_need_to_short = true;
        }
        if (
          (wanted_date_start.isSameOrBefore(appointement_start) &&
            wanted_date_end.isSameOrAfter(appointement_end)) ||
          (wanted_date_start.isSame(appointement_start) &&
            wanted_date_end.isSame(appointement_end))
        ) {
          error_contain_app = true;
        }
      }
      if (error_need_to_short || error_contain_app) {
        return true;
      }
      return false;
    },
    adjustmentAppTime(start, end, appId, isPrivate = false) {
      const wantedDateStart = this.$moment(start);
      const wantedDateEnd = this.$moment(end);
      const duration = this.$moment
        .duration(wantedDateEnd.diff(wantedDateStart))
        .asMinutes();
      // find block
      let block = null;
      let blocks = this.events.filter(
        ev =>
          ev.type === "block" && this.getDate(start) === this.getDate(ev.start)
      );
      if (isPrivate) blocks = blocks.filter(ev => !ev.is_private);
      if (!blocks || !blocks.length) return null;
      for (let i = 0; i < blocks.length; i++) {
        const blockStart = this.$moment(blocks[i].start, "YYYY-MM-DD HH:mm:ss");
        const blockEnd = this.$moment(blocks[i].end, "YYYY-MM-DD HH:mm:ss");
        if (
          wantedDateEnd.isSameOrAfter(blockStart) &&
          blockEnd.isSameOrAfter(wantedDateStart)
        ) {
          block = blocks[i];
          break;
        }
      }
      if (!block) return null;
      // find apps
      let todayApps = this.events.filter(
        ev =>
          ev.type === "appointment" &&
          this.getDate(start) === this.getDate(ev.start) &&
          ev.id !== appId &&
          ev.parent_block_id == block.id
      );
      const blockStart = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss");
      const blockEnd = this.$moment(block.end, "YYYY-MM-DD HH:mm:ss");
      // if not apps
      if (!todayApps || !todayApps.length) {
        if (wantedDateStart.isBefore(blockStart)) {
          // before block start
          let newEnd = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss").add(
            duration,
            "minutes"
          );
          if (blockEnd.isSameOrAfter(newEnd)) {
            newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
            return { start: block.start, end: newEnd, blockId: block.id };
          }
        } else if (wantedDateEnd.isAfter(blockEnd)) {
          // after block end
          let newStart = this.$moment(
            block.end,
            "YYYY-MM-DD HH:mm:ss"
          ).subtract(duration, "minutes");
          if (newStart.isSameOrAfter(blockStart)) {
            newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
            return { start: newStart, end: block.end, blockId: block.id };
          }
        }
        return null;
      }
      // if apps
      todayApps = todayApps.sort((a, b) => a.start - b.start);
      for (let i = 0; i < todayApps.length; i++) {
        const appStart = this.$moment(
          todayApps[i].start,
          "YYYY-MM-DD HH:mm:ss"
        );
        const appEnd = this.$moment(todayApps[i].end, "YYYY-MM-DD HH:mm:ss");
        // before block start
        if (wantedDateStart.isBefore(blockStart) && i == 0) {
          let newEnd = this.$moment(block.start, "YYYY-MM-DD HH:mm:ss").add(
            duration,
            "minutes"
          );
          if (appStart.isSameOrAfter(newEnd) && newEnd.isBefore(blockEnd)) {
            newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
            return { start: block.start, end: newEnd, blockId: block.id };
          }
        }
        // after block end
        if (wantedDateEnd.isAfter(blockEnd)) {
          const lastAppEnd = this.$moment(
            todayApps[todayApps.length - 1].end,
            "YYYY-MM-DD HH:mm:ss"
          );
          let newStart = this.$moment(
            block.end,
            "YYYY-MM-DD HH:mm:ss"
          ).subtract(duration, "minutes");
          if (
            newStart.isSameOrAfter(lastAppEnd) &&
            newStart.isAfter(blockStart)
          ) {
            newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
            return { start: newStart, end: block.end, blockId: block.id };
          }
        }
        // between apps
        if (wantedDateStart.isAfter(appStart) && todayApps[i + 1]) {
          let nextAppStart = this.$moment(
            todayApps[i + 1].start,
            "YYYY-MM-DD HH:mm:ss"
          );
          // wanted start before app end
          if (wantedDateStart.isBefore(appEnd)) {
            let newEnd = this.$moment(
              todayApps[i].end,
              "YYYY-MM-DD HH:mm:ss"
            ).add(duration, "minutes");
            if (
              nextAppStart.isSameOrAfter(newEnd) &&
              newEnd.isBefore(blockEnd)
            ) {
              newEnd = new Date(newEnd.format("YYYY-MM-DDTHH:mm"));
              return { start: appEnd, end: newEnd, blockId: block.id };
            }
          }
          // wanted end after start app
          if (wantedDateEnd.isAfter(nextAppStart)) {
            let newStart = this.$moment(
              todayApps[i + 1].start,
              "YYYY-MM-DD HH:mm:ss"
            ).subtract(duration, "minutes");
            if (
              nextAppStart.isSameOrAfter(newStart) &&
              newStart.isSameOrAfter(appEnd) &&
              newStart.isAfter(blockStart)
            ) {
              newStart = new Date(newStart.format("YYYY-MM-DDTHH:mm"));
              return {
                start: newStart,
                end: nextAppStart.format("YYYY-MM-DDTHH:mm"),
                blockId: block.id
              };
            }
          }
        }
      }
      return null;
    },
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, false);
    },
    updateCurrDropOpen(id) {
      this.currentOpenDrop = id;
    },
    /**
     * Remove fake time that crated for better view
     * and change time step
     */
    changeTimeStep() {
      if (this.viewBySelect == "day") {
        const selectedDate = this.getDate(this.selectedDate);
        const selectedDateEvents = this.events.filter(
          e =>
            e.type === "appointment" &&
            selectedDate === this.getDate(e.start) &&
            this.getDuration(e.start, e.real_end) <= 5
        );
        if (selectedDateEvents && selectedDateEvents.length) {
          this.timeStep = 5;
          this.copyEvents = this.events.map(e => {
            if (e.type == "block") return { ...e };
            return { ...e, end: e.real_end, start: e.real_start };
          });
          return;
        }
      }
      this.timeStep = 15;
      this.copyEvents = [...this.events];
    },
    exportToExcel() {
      exportAppointmentsToExcel(this.appointmentList);
    }
  },
  created() {
    this.copyEvents = [...this.events];
    if (this.hashData && this.hashData.date) {
      this.activeView =
        this.hashData.view === "list" ? "day" : this.hashData.view;
      this.viewBySelect = this.hashData.view;
      this.selectedDate = new Date(this.hashData.date);
      this.changeTimeStep();
    } else {
      this.activeView = "month";
      this.viewBySelect = "month";
      this.selectedDate = new Date();
      window.location.hash = getHash({
        date: this.$moment(new Date()).format("YYYY-MM-DD"),
        view: this.viewBySelect
      });
    }
    setTimeout(() => {
      this.$emit("initCalendarDesktop", {
        currentDate: this.selectedDate,
        forceUpdate: true,
        type: "both"
      });
    }, 1500);
  }
};
</script>

<style>
.select2-results li:first-child.select2-results__option {
  display: block !important;
}

.hover {
  background-color: rgb(165, 164, 164);
  z-index: 100;
  position: fixed;
  top: 0;
}

.no_mobile .vuecal__cell-events-count {
  display: none;
}

.no_mobile .vuecal--month-view .calendar_desktop.vuecal__cell {
  height: 150px;
}

.no_mobile .vuecal--month-view .calendar_desktop.vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.no_mobile .vuecal--month-view .calendar_desktop.vuecal__cell-date {
  padding: 4px;
}
.no_mobile .vuecal--month-view .calendar_desktop.vuecal__no-event {
  display: none;
}

.Block .vuecal__event-resize-handle {
  display: none !important;
}
</style>
